/*
 * Copyright (c) 2026. BrightNight. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */

import { createContext, useContext } from 'react';
import type { DesktopNavigate, DesktopRouterLocation } from './DesktopRouter';

/** Navigation for chrome outside desktop windows, where no router exists. */
export interface ShellNavigation {
  /** True when an ambient react-router already serves this subtree (tests, Storybook). */
  ambientRouter?: boolean;
  /** History move; applies to the focused window. */
  go: (delta: number) => void;
  /** The focused window location, or a desktop-level URL. */
  location: DesktopRouterLocation;
  /** Opens the page in the window of the app that owns it. */
  navigate: DesktopNavigate;
}

export const ShellNavigationContext = createContext<ShellNavigation | null>(null);

export function useShellNavigationContext() {
  const context = useContext(ShellNavigationContext);
  if (!context) {
    throw new Error('Shell navigation requires a DesktopProvider or RouterShellNavigation');
  }
  return context;
}
